import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MAIN_URL } from 'src/app/constant/app-constant';

@Injectable({
  providedIn: 'root'
})
export class BusinessService {

  constructor(private http: HttpClient) { }

  getAllNews(): Observable<any> {
    return this.http.get<any>(MAIN_URL + "post/allpost");
  }

  getPostByPagination(pageIndex: number): Observable<any> {
    return this.http.get<any>(MAIN_URL + "post/PostPagination/" + pageIndex + "");
  }

  getBusinessNews(catg_id:number,page:number,limit:number):Observable<any>{
    return this.http.get<any>(MAIN_URL + "post/categoryPostPagination/" + catg_id + "/" + page + "/"+limit+"/");
  }

}
